import React from 'react';
import { 
  IconButton, 
  Menu, 
  MenuItem, 
  ListItemIcon, 
  ListItemText,
  useTheme
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';
import { useThemeMode } from '../contexts/ThemeContext';

const LanguageSelector = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { i18n, t } = useTranslation();
  const theme = useTheme();
  const { mode } = useThemeMode();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-label={t('language.select')}
        aria-haspopup="menu"
        sx={{
          color: mode === 'dark' ? 'white' : 'black',
          '&:hover': {
            backgroundColor: mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.08)' 
              : 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 150,
            boxShadow: theme.shadows[3]
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => changeLanguage('tr')}>
          <ListItemIcon>🇹🇷</ListItemIcon>
          <ListItemText>{t('language.tr')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => changeLanguage('en')}>
          <ListItemIcon>🇬🇧</ListItemIcon>
          <ListItemText>{t('language.en')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSelector; 